import { MDBFooter } from 'mdb-react-ui-kit';

export default function () {
  return (
    <MDBFooter bgColor='light' className='text-center text-lg-left'>
      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        &copy; {new Date().getFullYear()} Copyright:{' '}
        <a className='text-dark' href='#/'>
          Stable Diffusion 中文技术社区 | 京ICP备2022031055号
        </a>
      </div>
    </MDBFooter>
  )
}